<template>
  <div>
    <el-radio-group
      v-model="prizetype"
      @change="function(e){
              skuType(e)
            }"
    >
      <el-radio :label="0">无奖品</el-radio>
      <el-radio :label="1">实体物品</el-radio>
      <el-radio :label="2">克拉数(如果选中克拉数,则你输入的数会被除于10000)</el-radio>
      <el-radio :label="3">优惠券</el-radio>
      <el-radio :label="4">经验值</el-radio>
      <el-radio :label="5">抽奖机会</el-radio>
      <el-radio :label="6">勋章</el-radio>
      <el-radio :label="7">属性值</el-radio>
      <el-radio :label="8">机会卷</el-radio>
      <el-radio :label="9">打卡任务</el-radio>
      <el-radio :label="10">委托卡片</el-radio>
      <el-radio style="margin-top:10px" :label="11">大赛资格</el-radio>
      <el-radio style="margin-top:10px" :label="12">地图资格</el-radio>
      <el-radio style="margin-top:10px" :label="13">现金红包(数量=分)</el-radio>
    </el-radio-group>
    <el-input
      v-model="prizevals"
      placeholder="请输入虚拟物品值(id)"
      :clearable="true"
      :disabled="prizetype == 0 || 1||2||4 ? true :false"
      v-if="prizetype == 0|| prizetype == 1 ||prizetype == 2 ||prizetype == 4"
    ></el-input>
    <el-select
      v-if="prizetype == 3"
      clearable
      class="filter-item"
      v-model="prizevals"
      placeholder="请选择优惠券"
      style="margin-right: 20px;"
      @change="getselect"
    >
      <el-option v-for="item in couponsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select
      v-if="prizetype == 5"
      clearable
      class="filter-item"
      v-model="prizevals"
      placeholder="请选择抽奖"
      style="margin-right: 20px;"
      @change="getselect"
    >
      <el-option v-for="item in rafflesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select
      v-if="prizetype == 6"
      clearable
      class="filter-item"
      v-model="prizevals"
      placeholder="请选择勋章"
      style="margin-right: 20px;"
      @change="getselect"
    >
      <el-option v-for="item in medalsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select v-model="prizevals" placeholder="请选择属性" @change="getselect" v-if="prizetype == 7">
      <el-option-group v-for="group in options" :key="group.label" :label="group.label">
        <el-option
          v-for="item in group.options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-option-group>
    </el-select>
    <el-select
      v-if="prizetype == 8"
      clearable
      class="filter-item"
      v-model="prizevals"
      placeholder="请选择委托"
      style="margin-right: 20px;"
      @change="getselect"
    >
      <el-option v-for="getCR in getCRsList" :key="getCR.id" :label="getCR.name" :value="getCR.id"></el-option>
    </el-select>
    <el-select
      v-if="prizetype == 9"
      clearable
      filterable
      class="filter-item"
      v-model="prizevals"
      placeholder="请选择打卡任务"
      style="margin-right: 20px;"
      @change="getselect"
    >
      <el-option
        v-for="getCR in getsThemeList"
        :key="getCR.id"
        :label="getCR.title"
        :value="getCR.id"
      ></el-option>
    </el-select>
    <el-select
      v-if="prizetype == 10"
      clearable
      class="filter-item"
      v-model="value2"
      placeholder="请选择委托"
      style="margin-right: 20px;"
      @change="function(e){
              skusType(e)
            }"
    >
      <el-option v-for="getCR in getCRsList" :key="getCR.id" :label="getCR.name" :value="getCR.id"></el-option>
    </el-select>
    <el-select
      v-if="prizetype == 10"
      clearable
      class="filter-item"
      v-model="prizevals"
      placeholder="请选择委托卡片"
      style="margin-right: 20px;"
      @change="getselect"
      :disabled="value2 == ''"
    >
      <el-option
        v-for="getCR in getCardList"
        :key="getCR.id"
        :label="getCR.companyName + ' -酬劳:'+getCR.reward"
        :value="getCR.id"
      ></el-option>
    </el-select>
    <el-select
      v-if="prizetype == 11"
      clearable
      class="filter-item"
      v-model="prizevals"
      placeholder="请选择大赛"
      @change="getselect"
      style="margin-right: 20px;"
    >
      <el-option v-for="item in megagameList" :key="item.id" :label="item.title" :value="item.id"></el-option>
    </el-select>
    <el-select
      v-if="prizetype == 12"
      clearable
      class="filter-item"
      v-model="prizevals"
      placeholder="请选择地图"
      @change="getselect"
      style="margin-right: 20px;"
    >
      <el-option v-for="item in mapList" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>

  </div>
</template>
<script>
import { attList } from '@/api/demo/attributes/index'
import { getArrList } from '@/api/demo/discount/index'
import { getLuckList } from '@/api/demo/luckDraw/index'
import { getMedalList } from '@/api/demo/medal/index'
import { getCRList, getCard } from '@/api/demo/CommissionRelate/index'
import { getThemeList } from '@/api/demo/punchInActivity/index'
import { megagameList } from '@/api/demo/competition/index'
import { getMapList } from '@/api/demo/map'
export default {
  props: {
    type: {
      type: Number,
      default: 0
    },
    prizeindex: {
      type: Number,
      default: 0
    },
    prizesindex: {
      type: Number,
      default: 0
    },
    prizeval: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      prizetype: 0,
      getCardList: [],
      value2: '',
      prizevals: '',
      couponsList: [], // 优惠券列表
      rafflesList: [], // 抽奖列表
      medalsList: [], // 勋章列表
      getCRsList: [], // 委托管理
      getsThemeList: [], // 打卡任务
      megagameList: [], // 大赛
      mapList: [], // 地图
      options: [
        { label: '亲密关系', options: [] },
        { label: '气质特征', options: [] },
        { label: '能力属性', options: [] },
        { label: '影响力', options: [] }
      ]
    }
  },
  created () {
    let that = this
    that.couponList()
    that.raffleList()
    that.medalList()
    that.getAttributes()
    that.getCRList()
    that.getThemesList()
    that.getMegagameList()
    that.getMapList()
  },
  watch: {
    type: {
      handler (newVal, oldVal) {
        // console.log(newVal, oldVal, "这样也可以得到数据~~~");
        this.prizetype = newVal
      },
      immediate: true,
      deep: true
    },
    prizeval: {
      handler (newVal, oldVal) {
        this.prizevals = newVal
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 类型
    skuType (e) {
      let that = this
      that.prizetype = e
      that.prizevals = ''
      this.$emit('skuType', e, that.prizeindex, that.prizesindex)
    },
    // 大赛
    getMegagameList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 40,
        keyword: '',
        classifyId: ''
      }
      megagameList(listQuery).then(res => {
        that.megagameList = res.records
      })
    },
    getMapList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 100,
        keyword: '',
        classifyId: ''
      }
      getMapList(listQuery).then(res => {
        that.mapList = res.records
      })
    },
    // 优惠券
    couponList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 100,
        keyword: '',
        stat: 1,
        type: ''
      }
      getArrList(listQuery).then(res => {
        that.couponsList = res.records
      })
    },
    // 抽奖列表
    raffleList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        name: null, // 名称
        pageSize: 200, // 每页显示的大小
        status: 1 // 状态
      }
      getLuckList(listQuery).then(res => {
        that.rafflesList = res.records
      })
    },
    // 勋章列表
    medalList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200 // 每页显示的大小
      }
      getMedalList(listQuery).then(res => {
        that.medalsList = res.records
      })
    },
    // 获取属性相关
    getAttributes () {
      let listQuery = {
        currentPage: 1,
        pageSize: 40
      }
      attList(listQuery, 1).then(res => {
        res.records.forEach(item => {
          this.options[0].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 2).then(res => {
        res.records.forEach(item => {
          this.options[1].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 4).then(res => {
        res.records.forEach(item => {
          this.options[2].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 5).then(res => {
        res.records.forEach(item => {
          this.options[3].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
    },
    getCRList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200, // 每页显示的大小
        status: 1
      }
      getCRList(listQuery).then(res => {
        that.getCRsList = res.records
      })
    },
    // 获取打卡任务
    getThemesList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 2000,
        classifyId: null,
        keyword: null,
        status: 1
      }
      getThemeList(listQuery).then(res => {
        that.getsThemeList = res.records
      })
    },
    // 卡片列表
    getCardsList (e, index) {
      let that = this
      getCard(e).then(res => {
        that.getCardList = res
      })
    },
    skusType (e, index) {
      //   console.log("ee", e, index);
      let that = this
      if (e == '') {
      } else {
        that.getCardsList(e)
      }
    },
    getselect (e) {
      //   console.log("ee", e);
      let that = this
      that.$emit('getselect', e, that.prizeindex, that.prizesindex)
    }
  }
}
</script>
<style scoped>
</style>
